// extracted by mini-css-extract-plugin
export default {"container":"Reporting_container__Im2g-","card-content":"Reporting_card-content__sFybg","card-row":"Reporting_card-row__VtVyn","card-inputs":"Reporting_card-inputs__XZR4c"};